/* eslint-disable */
import React, { useState, useContext, useRef, useMemo } from 'react';
import { Data } from './contexts';
import { MonthlyPNLandBalValues, YTDPnlandBalCommonSizeValue, AnnualCashFlowValues, MonthlyCashFlowValues, AnnualKFIsValues, YTDPnlandBalValues, YTDCashFlowValues, MonthlyKFIsValues } from './report_components/MoneyHelpers';
import { buildImpactBox, impactBoxStatusColor, noSpecificTextMaker } from './report_components/ImpactBoxTextHelper';
import { ratioCalculations, netWorkingCapitalCalculation, netWorkingCapitalRatioCalculation, trailing12MonthCalculations } from './monthly/monthy_analysis_table_trailing12_calculations';
import { objReducer, calculateKFIMetric, calculateSeniorDebtToEBITDA, calculateEBITDAtoAnnualInterest, monthlyTotalRevenueGRCalc, monthlyPercentOfRevenueCalc, ytdPercentOfRevenueCalc, ytdTotalRevenueGRCalc } from './report_components/MoneyHelpers';
import { peopleCustomersT12Metrics, peersAnalysisPerCustomerVals } from './report_components/PeopleCustomersHelpers';
import GridLayout, { WidthProvider } from 'react-grid-layout';
import { COPY } from './charts/chart_helpers';
import { moneyCharts, pageCharts } from './charts';
import { getMultiDataBarChartOptions, get3DBubbleChartOptions, getQuadrantOptions, getScatterPlotOptions, format, getLineOrColOptions, getVerticalBarChartOptions, getHorizontalBarOptions, getStackedColumnOptions, getLineChartOptions } from './charts/DashBoardHighChartsHelper';
import WageDataScaffold from './tables/WageDataScaffold';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highcharts.js';
import highchartsMore from 'highcharts/highcharts-more.js';
import highchartsMap from 'highcharts/modules/map';
import solidGauge from 'highcharts/modules/solid-gauge.js';
import HC_exporting from 'highcharts/modules/exporting';
import offlineExporting from 'highcharts/modules/offline-exporting';
import drilldown from 'highcharts/modules/drilldown';
import { capitalize, parseMoney } from '../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLockOpen, faLock, faPencil } from '@fortawesome/free-solid-svg-icons';
import { SizeMe } from 'react-sizeme';
const ReactGridLayout = WidthProvider(GridLayout);
highchartsMore(Highcharts);
highchartsMap(Highcharts);
solidGauge(Highcharts);
HC_exporting(Highcharts);
offlineExporting(Highcharts);
drilldown(Highcharts);

const getYTDMonths = (data, ytdMonths) => {
    if (!data || !Array.isArray(ytdMonths)) return [];
    return ytdMonths.map((m) => data[m]);
};

const compareWithRowKeys = {
  'Peers - Top 10% Fastest Growing': 'top_10_revenue_growth',
  'Peers - Top 25% Fastest Growing': 'top_25_revenue_growth',
  'Peers - Top 10% Most Profitable': 'top_10_net_profit',
  'Peers - Top 25% Most Profitable': 'top_25_net_profit'
}

const ChildDashboard = (props) => {
    const { peerviewMetricsYears, calcs, monthly_calcs, trailing12, ytd_months } = useContext(Data);
    const avgAnnualCalcs = props.aggregateData ? props.aggregateData?.annual : calcs
    const monthlyCalcs = props.reportPeriod === 'Trailing 12' ? trailing12 : monthly_calcs;
    const avgMonthlyCalcs = props.aggregateData && props.report_period === 'Trailing 12' ? props.aggregateData?.trailing12 : props.aggregateData ? props.aggregateData?.monthly : monthlyCalcs;
    let selectedYear = props.year;
    let previousYear = props.year - 1;
    let twoYearsAgo = props.year - 2;
    let threeYearsAgo = props.year - 3;
    const endMonthOfSelectedYear = props?.tabFilters?.date_through_monthly_month && props?.tabFilters?.date_through_monthly_year ? Number(props?.tabFilters?.date_through_monthly_month) : 12;
    const [chartRefs, setChartRefs] = useState({})
    const [timer, setTimer] = useState(null)
    const [showChart, setShowChart] = useState(true)
    const [showImpactComment, setShowImpactComment] = useState(true)
    const colHeightPx = 199;
    const colWidthsPx = 203;
    // Get an object of all the highcharts refs so that they reflow() or force resizing when user resizes them in the react-grid-layout
    const setNewRef = (ref) => {
        if (ref) {
            let itemId = ref.container.current.id;
            chartRefs[itemId] = ref;
            setChartRefs(prevState => {
                return {
                    ...prevState,
                    itemId: ref
                }
            })
        }
    };

    const titleSetter = (chart) => {
        if (props.displayColumnsBy === 'Months' && chart.key === 'total_revenue_growth_rate') {
            return 'Monthly Revenue % of Annual Total Revenue'
        } else if (chart.copy) {
            if (chart.key.includes('labor_cogs')) {
                return `Labor COGS - ${chart.copy}`
            } else if (chart.parentKey === "total_costs") {
                return `COGS-${chart.copy}`
            } else {
                return chart.copy
            }
        } else {
            return (chart.title ? chart.title : COPY[chart.key])
        }
    }

    const buildHorizonalBarSeries = (chart) => {
        if (props.page === 'industryCustomers') {
            let vals = chart.keys.map((key) => {
                let val = calcs['avg'][key][props.year];
                return val ? (Math.round(val * 10) / 10) : null;
            })

            return [{
                data: vals,
                showInLegend: false,
                name: 'avg',
                color: '#542667',
            }]

        } else {
            if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
                return ['you', 'avg'].map((g, i) => {
                    let dataCalcs = g == 'avg' ? avgAnnualCalcs : calcs
                    let dataName = g === 'avg' ? 'Peers' : 'You';
                    let vals = chart.keys.map((key) => {
                        let val = dataCalcs[g][key][props.year];
                        return val ? (Math.round(val * 10) / 10) : null;
                    })

                    return {
                        data: vals,
                        showInLegend: true,
                        name: dataName,
                        color: dataName === 'You' ? '#542667' : '#ae6dc9',
                    }
                })
            }

            return ['you', 'avg'].map((g, i) => {
                let dataName = g === 'avg' ? 'Peers' : 'You';

                return {
                    data: [0, 0],
                    showInLegend: true,
                    name: dataName,
                    color: dataName === 'You' ? '#542667' : '#ae6dc9',
                }
            })
        }
    }

    const buildLineSeries = (chart) => {
        if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
            return ['you', 'avg'].map((g, i) => {
                let dataCalcs = g == 'avg' ? avgAnnualCalcs : calcs
                let dataName = g === 'avg' ? 'Peers' : 'You';
                let vals = chart.keys.map((key) => {
                    // need latest year for cltv70, 80, 90
                    let val = dataCalcs[g][key][props.year];
                    return val ? val : null;
                })

                return {
                    data: vals,
                    showInLegend: true,
                    name: dataName,
                    title: dataName,
                    color: dataName === 'You' ? '#542667' : '#ae6dc9',
                    _symbolIndex: i,
                }
            })
        }
        return ['you', 'avg'].map((g, i) => {
            let dataName = g === 'avg' ? 'Peers' : 'You';

            return {
                data: [0, 0],
                showInLegend: true,
                name: dataName,
                color: dataName === 'You' ? '#542667' : '#ae6dc9',
            }
        })
    }

    const buildVerticalBarData = (chart, set) => {
        let value = null;
        if (props.displayColumnsBy !== 'Months' && props.reportPeriod !== 'Year to Date') {
            if (set === 'you' && calcs['you']) {
                value = calcs['you']?.[chart.key]?.[props.year];
            }
            if (set === 'Peers' && avgAnnualCalcs['avg']) {
                value = avgAnnualCalcs['avg']?.[chart.key]?.[props.year];
            }
            if (compareWithRowKeys[set] && avgAnnualCalcs[compareWithRowKeys[set]]) {
                value = avgAnnualCalcs[compareWithRowKeys[set]]?.[chart.key]?.[props.year];
            }
            if (set === 'YOY' && calcs['you']) {
                value = calcs['you']?.[chart.key]?.[props.year - 1];
            }
            if (set === 'Practice' && avgAnnualCalcs['practice_avg']) {
                value = avgAnnualCalcs['practice_avg']?.[chart.key]?.[props.year];
            }
            if (set === 'NSCHBC' && avgAnnualCalcs['nschbc']) {
                value = avgAnnualCalcs['nschbc']?.[chart.key]?.[props.year];
            }

        } else {
            let monthNumber = 0;
            let useableMonths;
            let metrics = set === 'you' ? props.youMetrics : props.compareMetrics;
            if (props.displayColumnsBy === 'Months') {
                useableMonths = monthlyCalcs?.['you']?.['roa']?.[selectedYear] ? Object.values(monthlyCalcs?.['you']?.['roa']?.[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
                useableMonths.forEach(thing => thing !== null ? monthNumber += 1 : null);
            } else if (props.reportPeriod === 'Year to Date') {
                monthNumber = ytd_months[ytd_months.length - 1]
                useableMonths = ytd_months;
            }
            if (metrics[chart.key]) {
                value = Math.round(metrics[chart.key][monthNumber]);
            }
        }

        return value;
    }

    // Used by AP and AR Aging Summary Reports
    const buildAPARAgingSeries = (chart) => {
        let returnSeries;
        let firstData = [];
        let secondData = [];
        let thirdData = [];
        let fourthData = [];
        let currentData = [];
        let apOrAr = chart.key === 'ap_aging_summary' ? 'ap' : 'ar';
        let agingKey91Over = apOrAr + '_91_and_over';
        let agingKey6191 = apOrAr + '_61_90';
        let agingKey3160 = apOrAr + '_31_60';
        let agingKey130 = apOrAr + '_1_30';
        let agingKeyCurrent = apOrAr + '_current';

        if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
            chart.years.forEach(year => {
                firstData.push(calcs['you'][agingKey91Over][year])
                secondData.push(calcs['you'][agingKey6191][year])
                thirdData.push(calcs['you'][agingKey3160][year])
                fourthData.push(calcs['you'][agingKey130][year])
                currentData.push(calcs['you'][agingKeyCurrent][year])
            })
            returnSeries = [
                {
                    name: '91 and over',
                    color: '#ffb74d',
                    data: firstData
                },
                {
                    name: '61-90',
                    color: '#999',
                    data: secondData
                },
                {
                    name: '31-60',
                    color: '#542667',
                    data: thirdData
                },
                {
                    name: '1-30',
                    color: '#00aeef',
                    data: fourthData
                },
                {
                    name: 'Current',
                    color: '#69b144',
                    data: currentData
                }
            ]
        }

        if (props.reportPeriod === 'Year to Date') {
            chart.years.forEach(year => {
                let firstVals = monthlyCalcs['you']?.[agingKey91Over]?.[year] ? getYTDMonths(monthlyCalcs['you'][agingKey91Over][year]) : [];
                let secondVals = monthlyCalcs['you']?.[agingKey6191]?.[year] ? getYTDMonths(monthlyCalcs['you'][agingKey6191][year]) : [];
                let thirdVals = monthlyCalcs['you']?.[agingKey3160]?.[year] ? getYTDMonths(monthlyCalcs['you'][agingKey3160][year]) : [];
                let fourthVals = monthlyCalcs['you']?.[agingKey130]?.[year] ? getYTDMonths(monthlyCalcs['you'][agingKey130][year]) : [];
                let currentVals = monthlyCalcs['you']?.[agingKeyCurrent]?.[year] ? getYTDMonths(monthlyCalcs['you'][agingKeyCurrent][year]) : [];
                firstData.push(firstVals[firstVals.length - 1])
                secondData.push(secondVals[secondVals.length - 1])
                thirdData.push(thirdVals[thirdVals.length - 1])
                fourthData.push(fourthVals[fourthVals.length - 1])
                currentData.push(currentVals[currentVals.length - 1])
            })
            returnSeries = [
                {
                    name: '91 and over',
                    color: '#ffb74d',
                    data: firstData
                },
                {
                    name: '61-90',
                    color: '#999',
                    data: secondData
                },
                {
                    name: '31-60',
                    color: '#542667',
                    data: thirdData
                },
                {
                    name: '1-30',
                    color: '#00aeef',
                    data: fourthData
                },
                {
                    name: 'Current',
                    color: '#69b144',
                    data: currentData
                }
            ]
        }

        if (props.displayColumnsBy === 'Months') {
            returnSeries = [
                {
                    name: '91 and over',
                    color: '#ffb74d',
                    data: Object.values(monthlyCalcs['you']?.[agingKey91Over]?.[selectedYear]).slice(0, endMonthOfSelectedYear)
                },
                {
                    name: '61-90',
                    color: '#999',
                    data: Object.values(monthlyCalcs['you']?.[agingKey6191]?.[selectedYear]).slice(0, endMonthOfSelectedYear)
                },
                {
                    name: '31-60',
                    color: '#542667',
                    data: Object.values(monthlyCalcs['you']?.[agingKey3160]?.[selectedYear]).slice(0, endMonthOfSelectedYear)
                },
                {
                    name: '1-30',
                    color: '#00aeef',
                    data: Object.values(monthlyCalcs['you']?.[agingKey130]?.[selectedYear]).slice(0, endMonthOfSelectedYear)
                },
                {
                    name: 'Current',
                    color: '#69b144',
                    data: Object.values(monthlyCalcs['you']?.[agingKeyCurrent]?.[selectedYear]).slice(0, endMonthOfSelectedYear)
                }
            ]
        }
        return returnSeries;
    }

    const peoplePercentKeys = ['sum_compensation_growth_rate', 'sum_taxes_and_benefits_growth_rate', 'sum_subcontractors_growth_rate', 'turnover_rate']
    const peopleKpiT12 = ['total_revenue_per_employee', 'operating_expenses_net_income_per_employee', 'average_wages_and_salaries', 'average_benefits', 'cost_of_turnover', 'number_of_employees_who_left', 'sum_compensation_growth_rate', 'sum_compensation_per_employee', 'sum_health_insurance_per_employee', 'sum_payroll_per_employee', 'sum_retirement_per_employee', 'sum_subcontractors_growth_rate', 'sum_taxes_and_benefits_growth_rate', 'sum_taxes_and_benefits_per_employee', 'total_number_of_employees', 'training_per_employee', 'turnover_rate']
    const customerKPIKeys = ['revenue_per_customer', 'gross_profit_per_customer', 'operating_expenses_net_income_per_customer', 'total_customer_costs_common_size_revenue', 'number_of_new_customers_needed_to_maintain_growth']
    const customerPercentKeys = ['percent_of_sales_from_the_top_10_percent', 'percent_of_sales_from_the_top_25_percent', 'percent_of_sales_from_the_top_50_percent', 'customer_roi']
    const buildYouLineOrColData = (chart, sheet = '') => {
        const key = chart.key;
        let dataMap = [];
        let page = props.page
        let parentMetric = props.parentDashBoardInfo
        if (page === 'money' && ['people_financial_detail', 'people_kpi'].includes(parentMetric.sheet)) {
            page = 'people'
        } else if (page === 'money' && ['customers_financial_detail', 'customers_kpi'].includes(parentMetric.sheet)) {
            page = 'customers'
        }

        if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
            dataMap = chart.years.map(year => {
                let value;
                try {
                    if (key === 'net_working_capital') {
                        let totalCurrentAssets = calcs['you']['total_current_assets'][year];
                        let totalCurrentLiabilities = calcs['you']['total_current_liabilities'][year];
                        value = totalCurrentAssets - totalCurrentLiabilities;
                    } else if (key === 'senior_debt_to_ebitda') {
                        let longTermDebt = calcs['you']['long_term_debt'][year];
                        let lineOfCredit = calcs['you']['line_of_credit'][year];
                        let currentPortionOfLTD = calcs['you']['current_portion_of_ltd'][year];
                        let netIncome = calcs['you']['operating_expenses_net_income'][year];
                        let interest = calcs['you']['interest_and_other_expenses'][year];
                        let taxes = calcs['you']['total_other_costs_taxes_- federal & state'][year];
                        let deprAmor = calcs['you']['depreciation_and_amortization'][year];
                        let ebitda = netIncome + interest + taxes + deprAmor;
                        value = (longTermDebt + lineOfCredit + currentPortionOfLTD) / ebitda;
                    } else if (key === 'ebitda_to_annual_interest') {
                        let netIncome = calcs['you']['operating_expenses_net_income'][year];
                        let interest = calcs['you']['interest_and_other_expenses'][year];
                        let taxes = calcs['you']['total_other_costs_taxes_- federal & state'][year];
                        let deprAmor = calcs['you']['depreciation_and_amortization'][year];
                        let ebitda = netIncome + interest + taxes + deprAmor;
                        value = ebitda / interest;
                    } else if (customerKPIKeys.includes(key)) {
                        value = calcs['you'][key][year]
                    } else if (customerPercentKeys.includes(key) || peoplePercentKeys.includes(key)) {
                        value = calcs['you'][key][year] / 100
                    } else if (sheet === 'pnl' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
                        value = calcs['you'][key + '_common_size_revenue'][year]
                    } else if (sheet === 'balance_sheet') {
                        value = calcs['you'][key + '_common_size_assets'][year]
                    } else {
                        value = calcs.you[key][year];
                    }
                    return value ? value : null;
                } catch (e) {
                    return null;
                }
            })
        }

        if (props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date') {
            if (page === 'money' || page === 'people' || page === 'customers') {
                dataMap = chart.years.map(year => {
                    try {
                        if (chart.percentOfRevenueKey) {
                            let value = ytdPercentOfRevenueCalc(chart.percentOfRevenueKey, key, monthlyCalcs['you'], year, ytd_months);
                            return value;
                        } else if (key === 'senior_debt_to_ebitda') {
                            let value = calculateSeniorDebtToEBITDA(monthlyCalcs['you'], year, ytd_months)
                            return value;
                        } else if (key === 'ebitda_to_annual_interest') {
                            let value = calculateEBITDAtoAnnualInterest(monthlyCalcs['you'], year, ytd_months)
                            return value;
                        } else if (key === 'total_revenue_growth_rate') {
                            let totalRevenueGR = ytdTotalRevenueGRCalc(monthlyCalcs['you'], year, year - 1, ytd_months)
                            return totalRevenueGR;
                        } else if (peopleKpiT12.includes(key) || customerKPIKeys.includes(key) || key === 'customer_roi' || key === 'number_of_new_customers_needed_to_maintain_growth') {
                            let lastMonthNumber = ytd_months[ytd_months.length - 1]
                            let useableMonths = ytd_months
                            let t12Obj = peopleCustomersT12Metrics(page, key, monthlyCalcs.you, year, year - 1, year - 2, true, ytd_months, 'you')
                            return t12Obj[key][lastMonthNumber]
                        } else if (sheet === 'pnl' || sheet === 'balance_sheet' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
                            const currentYearYTDYou = monthlyCalcs?.you?.[key]?.[year];
                            let value = YTDPnlandBalValues(sheet, key, currentYearYTDYou, year, ytd_months, monthlyCalcs?.you)
                            let finalVal = YTDPnlandBalCommonSizeValue(value, sheet, year, ytd_months, monthlyCalcs?.you)
                            return finalVal;
                        } else {
                            let value = calculateKFIMetric(key, monthlyCalcs['you'], year, year - 1, ytd_months)
                            return value;
                        }
                    } catch (e) {
                        return null;
                    }
                })
            } else {
                let selectedYearVal, previousYearVal = null;
                let lastMonthNumber = ytd_months[ytd_months.length - 1]
                let useableMonths = ytd_months

                if (key === 'total_revenue' || key === 'gross_profit' || key === 'operating_expenses_net_income') {
                    selectedYearVal = getYTDMonths(monthlyCalcs['you'][key][props.year], ytd_months).reduce((a, b) => a + b, 0);
                    previousYearVal = getYTDMonths(monthlyCalcs['you'][key][props.year - 1], ytd_months).reduce((a, b) => a + b, 0);
                } else {
                    if (props.youMetrics[key]) {
                        selectedYearVal = props.youMetrics[key][lastMonthNumber];
                    }
                    if (props.youPreviousYearMetricsYTD[key]) {
                        previousYearVal = props.youPreviousYearMetricsYTD[key][lastMonthNumber];
                    }
                }
                dataMap = [previousYearVal, selectedYearVal]
            }
        }

        if (props.displayColumnsBy === 'Months') {
            let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
            if (page === 'money' || page === 'people' || page === 'customers') {
                if (chart.trailing12Key) {
                    let trailing12Obj = trailing12MonthCalculations(chart.trailing12Key, monthlyCalcs.you, selectedYear, previousYear);
                    dataMap = Object.values(trailing12Obj).slice(0, endMonthOfSelectedYear);
                } else if (chart.percentOfRevenueKey) {
                    let percentOfRevenueObj = monthlyPercentOfRevenueCalc(chart.percentOfRevenueKey, key, monthlyCalcs.you, selectedYear);
                    dataMap = Object.values(percentOfRevenueObj).slice(0, endMonthOfSelectedYear);
                } else if (key === 'current_ratio') {
                    let currentRatioObj = ratioCalculations('total_current_assets', monthlyCalcs.you, selectedYear)
                    dataMap = Object.values(currentRatioObj).slice(0, endMonthOfSelectedYear);
                } else if (key === 'net_working_capital_ratio') {
                    let netWorkingCapRatioObj = netWorkingCapitalRatioCalculation(monthlyCalcs.you, selectedYear)
                    dataMap = Object.values(netWorkingCapRatioObj).slice(0, endMonthOfSelectedYear);
                } else if (key === 'net_working_capital') {
                    let netWorkingCapitalObj = netWorkingCapitalCalculation(monthlyCalcs.you, selectedYear)
                    dataMap = Object.values(netWorkingCapitalObj).slice(0, endMonthOfSelectedYear)
                } else if (key === 'total_revenue_growth_rate') {
                    let totalRevenueGR = monthlyTotalRevenueGRCalc(monthlyCalcs.you, selectedYear)
                    dataMap = Object.values(totalRevenueGR).slice(0, endMonthOfSelectedYear);
                } else if (peopleKpiT12.includes(key) || customerKPIKeys.includes(key) || key === 'customer_roi' || key === 'number_of_new_customers_needed_to_maintain_growth') {
                    let t12Obj = peopleCustomersT12Metrics(page, key, monthlyCalcs.you, selectedYear, previousYear, twoYearsAgo)
                    dataMap = t12Obj[key] ? Object.values(t12Obj[key]).slice(0, endMonthOfSelectedYear) : []
                } else if (sheet === 'pnl' || sheet === 'balance_sheet' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
                    let monthsAvailable = 0;
                    let useableMonths = monthlyCalcs?.['you']?.['cash']?.[selectedYear] ? Object.values(monthlyCalcs?.['you']?.['cash']?.[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
                    useableMonths.forEach(thing => thing !== null && !isNaN(thing) ? monthsAvailable += 1 : null);
                    const you = monthlyCalcs?.['you'] ? monthlyCalcs?.['you']?.[key]?.[selectedYear] : undefined;
                    dataMap = MonthlyPNLandBalValues(monthsAvailable, sheet, key, you, selectedYear, monthlyCalcs['you'])
                } else {
                    let returnObj = {};
                    let metricValues = _.pickBy(monthlyCalcs.you?.[key]?.[selectedYear], _.isNumber);
                    for (let month in metricValues) {
                        returnObj[month] = metricValues[month]
                    }
                    dataMap = Object.values(returnObj).slice(0, endMonthOfSelectedYear);
                }
            } else {
                let returnObj = {};
                let metricValues = _.pickBy(props.youMetrics?.[key], _.isNumber);
                for (let month in metricValues) {
                    returnObj[month] = metricValues[month]
                }
                dataMap = Object.values(returnObj).slice(0, endMonthOfSelectedYear);
            }
        }
        return dataMap;
    }

    const buildCompareLineOrColData = (chart, sheet = '') => {
        const key = chart.key;
        let analysisPerClientMetrics = ['revenue_per_customer', 'gross_profit_per_customer', 'operating_expenses_net_income_per_customer'];
        let dataMap = [];
        let page = props.page
        let parentMetric = props.parentDashBoardInfo
        if (page === 'money' && ['people_financial_detail', 'people_kpi'].includes(parentMetric.sheet)) {
            page = 'people'
        } else if (page === 'money' && ['customers_financial_detail', 'customers_kpi'].includes(parentMetric.sheet)) {
            page = 'customers'
        }

        if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
            dataMap = chart.years.map(year => {
                let value;
                let compareAvg = {}

                if (props.compareWith === 'Peers') {
                    compareAvg = avgAnnualCalcs['avg']
                } else if (compareWithRowKeys[props.compareWith]) {
                    compareAvg = avgAnnualCalcs[compareWithRowKeys[props.compareWith]]
                } else if (props.compareWith === 'Practice') {
                    compareAvg = avgAnnualCalcs['practice_avg']
                } else if (props.compareWith === 'NSCHBC') {
                    compareAvg = avgAnnualCalcs['nschbc']
                }

                try {
                    if (key === 'net_working_capital') {
                        let youTotalAssets = calcs['you']['total_assets'][year]
                        let totalCurrentAssetsCommonSize = compareAvg['total_current_assets_common_size_assets'][year];
                        let totalCurrentLiabilitiesCommonSize = compareAvg['total_current_liabilities_common_size_assets'][year];
                        value = (totalCurrentAssetsCommonSize * youTotalAssets) - (totalCurrentLiabilitiesCommonSize * youTotalAssets);
                    } else if (key === 'senior_debt_to_ebitda') {
                        let longTermDebt = compareAvg['long_term_debt'][year];
                        let lineOfCredit = compareAvg['line_of_credit'][year];
                        let currentPortionOfLTD = compareAvg['current_portion_of_ltd'][year];
                        let netIncome = compareAvg['operating_expenses_net_income'][year];
                        let interest = compareAvg['interest_and_other_expenses'][year];
                        let taxes = compareAvg['total_other_costs_taxes_- federal & state'][year];
                        let deprAmor = compareAvg['depreciation_and_amortization'][year];
                        let ebitda = netIncome + interest + taxes + deprAmor;
                        value = (longTermDebt + lineOfCredit + currentPortionOfLTD) / ebitda;
                    } else if (key === 'ebitda_to_annual_interest') {
                        let netIncome = compareAvg['operating_expenses_net_income'][year];
                        let interest = compareAvg['interest_and_other_expenses'][year];
                        let taxes = compareAvg['total_other_costs_taxes_- federal & state'][year];
                        let deprAmor = compareAvg['depreciation_and_amortization'][year];
                        let ebitda = netIncome + interest + taxes + deprAmor;
                        value = ebitda / interest;
                    } else if (page === 'customers' && analysisPerClientMetrics.includes(key)) {
                        value = peersAnalysisPerCustomerVals(key, year, compareAvg)
                    } else if (customerKPIKeys.includes(key)) {
                        value = compareAvg[key][year]
                    } else if (customerPercentKeys.includes(key) || peoplePercentKeys.includes(key)) {
                        value = compareAvg[key][year] / 100
                    } else if (sheet === 'pnl' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
                        value = compareAvg[key + '_common_size_revenue'] ? compareAvg[key + '_common_size_revenue'][year] : null;
                    } else if (sheet === 'balance_sheet') {
                        value = compareAvg[key + '_common_size_assets'] ? compareAvg[key + '_common_size_assets'][year] : null;
                    } else if (key === 'cash') {
                        let youTotalAssets = calcs['you']['total_assets'][year]
                        value = compareAvg[key + '_common_size_assets'] ? youTotalAssets * compareAvg[key + '_common_size_assets'][year] : null;
                    } else {
                        value = compareAvg[key][year];
                    }
                    return value ? value : null;
                } catch (e) {
                    return null;
                }
            })
        }

        if (props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date') {
            if (page === 'money' || page === 'people' || page === 'customers') {
                dataMap = chart.years.map(year => {
                    try {
                        if (chart.percentOfRevenueKey) {
                            let value = ytdPercentOfRevenueCalc(chart.percentOfRevenueKey, key, avgMonthlyCalcs['avg'], year, ytd_months);
                            return value;
                        } else if (key === 'senior_debt_to_ebitda') {
                            let value = calculateSeniorDebtToEBITDA(avgMonthlyCalcs['avg'], year, ytd_months)
                            return value;
                        } else if (key === 'ebitda_to_annual_interest') {
                            let value = calculateEBITDAtoAnnualInterest(avgMonthlyCalcs['avg'], year, ytd_months)
                            return value;
                        } else if (key === 'total_revenue_growth_rate') {
                            let totalRevenueGR = ytdTotalRevenueGRCalc(avgMonthlyCalcs['avg'], year, year - 1, ytd_months)
                            return totalRevenueGR;
                        } else if (peopleKpiT12.includes(key) || customerKPIKeys.includes(key) || key === 'customer_roi' || key === 'number_of_new_customers_needed_to_maintain_growth') {
                            let lastMonthNumber = ytd_months[ytd_months.length - 1]
                            let useableMonths = ytd_months
                            let t12Obj = peopleCustomersT12Metrics(page, key, avgMonthlyCalcs.avg, year, year - 1, year - 2, true, ytd_months, 'avg')
                            return t12Obj[key][lastMonthNumber]
                        } else if (sheet === 'pnl' || sheet === 'balance_sheet' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
                            const currentYearYTDCompare = avgMonthlyCalcs?.avg?.[key]?.[year];
                            let value = YTDPnlandBalValues(sheet, key, currentYearYTDCompare, year, ytd_months, avgMonthlyCalcs?.avg)
                            let finalVal = YTDPnlandBalCommonSizeValue(value, sheet, year, ytd_months, avgMonthlyCalcs?.avg)
                            return finalVal
                        } else {
                            let value = calculateKFIMetric(key, avgMonthlyCalcs['avg'], year, year - 1, ytd_months)
                            return value;
                        }
                    } catch (e) {
                        return null;
                    }
                })
            } else {
                let lastMonthNumber = ytd_months[ytd_months.length - 1]
                let useableMonths = ytd_months
                let selectedYearVal, previousYearVal = null;

                if (key === 'total_revenue' || key === 'gross_profit' || key === 'operating_expenses_net_income') {
                    selectedYearVal = getYTDMonths(avgMonthlyCalcs['avg'][key][props.year], ytd_months).reduce((a, b) => a + b, 0);
                    previousYearVal = getYTDMonths(avgMonthlyCalcs['avg'][key][props.year - 1], ytd_months).reduce((a, b) => a + b, 0);
                } else {
                    if (props.compareMetrics[key]) {
                        selectedYearVal = props.compareMetrics[key][monthNumber];
                    }
                    if (props.comparePreviousYearMetricsYTD[key]) {
                        previousYearVal = props.comparePreviousYearMetricsYTD[key][monthNumber];
                    }
                }

                dataMap = [previousYearVal, selectedYearVal]
            }
        }

        if (props.displayColumnsBy === 'Months') {
            let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

            if (page === 'money' || page === 'people' || page === 'customers') {
                if (chart.compareWith === 'YOY' || chart.compareWith === 'Default:YOY') {
                    if (chart.trailing12Key) {
                        let trailing12Obj = trailing12MonthCalculations(chart.trailing12Key, monthlyCalcs.you, previousYear, twoYearsAgo)
                        dataMap = Object.values(trailing12Obj).slice(0, endMonthOfSelectedYear);
                    } else if (chart.percentOfRevenueKey) {
                        let percentOfRevenueObj = monthlyPercentOfRevenueCalc(chart.percentOfRevenueKey, key, monthlyCalcs.you, previousYear);
                        dataMap = Object.values(percentOfRevenueObj).slice(0, endMonthOfSelectedYear);
                    } else if (key === 'current_ratio') {
                        let currentRatioObj = ratioCalculations('total_current_assets', monthlyCalcs.you, previousYear)
                        dataMap = Object.values(currentRatioObj).slice(0, endMonthOfSelectedYear);
                    } else if (key === 'net_working_capital_ratio') {
                        let netWorkingCapRatioObj = netWorkingCapitalRatioCalculation(monthlyCalcs.you, previousYear)
                        dataMap = Object.values(netWorkingCapRatioObj).slice(0, endMonthOfSelectedYear);
                    } else if (key === 'net_working_capital') {
                        let netWorkingCapitalObj = netWorkingCapitalCalculation(monthlyCalcs.you, previousYear)
                        dataMap = Object.values(netWorkingCapitalObj).slice(0, endMonthOfSelectedYear)
                    } else if (key === 'total_revenue_growth_rate') {
                        let totalRevenueGR = monthlyTotalRevenueGRCalc(monthlyCalcs.you, previousYear)
                        dataMap = Object.values(totalRevenueGR).slice(0, endMonthOfSelectedYear);
                    } else if (peopleKpiT12.includes(key) || customerKPIKeys.includes(key) || key === 'customer_roi' || key === 'number_of_new_customers_needed_to_maintain_growth') {
                        let t12Obj = peopleCustomersT12Metrics(page, key, monthlyCalcs.you, previousYear, twoYearsAgo, threeYearsAgo)
                        dataMap = Object.values(t12Obj[key]).slice(0, endMonthOfSelectedYear)
                    } else if (sheet === 'pnl' || sheet === 'balance_sheet' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
                        // previousYearCalcs and yoy_calcs are the same
                        const yoy = monthlyCalcs?.['you'] ? monthlyCalcs?.['you']?.[key]?.[previousYear] : undefined;
                        let monthsAvailable = 0;
                        let useableMonths = monthlyCalcs?.['you']?.['cash']?.[selectedYear] ? Object.values(monthlyCalcs?.['you']?.['cash']?.[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
                        useableMonths.forEach(thing => thing !== null && !isNaN(thing) ? monthsAvailable += 1 : null);
                        dataMap = MonthlyPNLandBalValues(monthsAvailable, sheet, key, yoy, previousYear, monthlyCalcs['you'])
                    } else {
                        let returnObj = {};
                        let metricValues = _.pickBy(monthlyCalcs.you?.[key]?.[previousYear], _.isNumber);
                        for (let month in metricValues) {
                            returnObj[month] = metricValues[month]
                        }
                        dataMap = Object.values(returnObj).slice(0, endMonthOfSelectedYear);
                    }
                }

                if (chart.compareWith === 'Peers' || chart.compareWith === 'Default:Peers') {
                    if (chart.trailing12Key) {
                        let trailing12Obj = trailing12MonthCalculations(chart.trailing12Key, avgMonthlyCalcs.avg, selectedYear, previousYear)
                        dataMap = Object.values(trailing12Obj);
                    } else if (chart.percentOfRevenueKey) {
                        let percentOfRevenueObj = monthlyPercentOfRevenueCalc(chart.percentOfRevenueKey, key, avgMonthlyCalcs.avg, selectedYear);
                        dataMap = Object.values(percentOfRevenueObj);
                    } else if (key === 'current_ratio') {
                        let currentRatioObj = ratioCalculations('total_current_assets', avgMonthlyCalcs.avg, selectedYear)
                        dataMap = Object.values(currentRatioObj);
                    } else if (key === 'net_working_capital_ratio') {
                        let netWorkingCapRatioObj = netWorkingCapitalRatioCalculation(avgMonthlyCalcs.avg, selectedYear)
                        dataMap = Object.values(netWorkingCapRatioObj);
                    } else if (key === 'net_working_capital') {
                        let netWorkingCapitalObj = netWorkingCapitalCalculation(avgMonthlyCalcs.avg, selectedYear)
                        dataMap = Object.values(netWorkingCapitalObj)
                    } else if (key === 'total_revenue_growth_rate') {
                        let totalRevenueGR = monthlyTotalRevenueGRCalc(avgMonthlyCalcs.avg, selectedYear)
                        dataMap = Object.values(totalRevenueGR);
                    } else if (peopleKpiT12.includes(key) || customerKPIKeys.includes(key) || key === 'customer_roi' || key === 'number_of_new_customers_needed_to_maintain_growth') {
                        let t12Obj = peopleCustomersT12Metrics(page, key, avgMonthlyCalcs.avg, selectedYear, previousYear, twoYearsAgo)
                        dataMap = Object.values(t12Obj[key])
                    } else if (sheet === 'pnl' || sheet === 'balance_sheet' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
                        const avg = avgMonthlyCalcs?.['avg'] ? avgMonthlyCalcs?.['avg']?.[key]?.[selectedYear] : undefined;
                        let monthsAvailable = 0;
                        let useableMonths = monthlyCalcs?.['you']?.['cash']?.[selectedYear] ? Object.values(monthlyCalcs?.['you']?.['cash']?.[selectedYear]) : [];
                        useableMonths.forEach(thing => thing !== null && !isNaN(thing) ? monthsAvailable += 1 : null);
                        dataMap = MonthlyPNLandBalValues(monthsAvailable, sheet, key, avg, selectedYear, avgMonthlyCalcs['avg'])
                    } else {
                        let returnObj = {};
                        let metricValues = _.pickBy(avgMonthlyCalcs.avg?.[key]?.[selectedYear], _.isNumber);
                        for (let month in metricValues) {
                            returnObj[month] = metricValues[month]
                        }
                        dataMap = Object.values(returnObj);
                    }
                }

                if (chart.compareWith.includes('Forecast') && props.forecastVals?.['total_revenue']) {
                    let compareSelectedYear = Object.keys(props.forecastVals?.['total_revenue'])[0]
                    if (chart.trailing12Key) {
                        let trailing12Obj = trailing12MonthCalculations(chart.trailing12Key, props.forecastVals, compareSelectedYear, previousYear, true, monthlyCalcs.you)
                        dataMap = Object.values(trailing12Obj);
                    } else if (chart.percentOfRevenueKey) {
                        let percentOfRevenueObj = monthlyPercentOfRevenueCalc(chart.percentOfRevenueKey, key, props.forecastVals, compareSelectedYear);
                        dataMap = Object.values(percentOfRevenueObj);
                    } else if (key === 'current_ratio') {
                        let numberOfMonths = 0
                        let useableMonths = Object.values(monthlyCalcs['you']?.['cash']?.[selectedYear]);
                        useableMonths.forEach(thing => thing !== null ? numberOfMonths += 1 : null)
                        let currentRatioObj = ratioCalculations('total_current_assets', props.forecastVals, compareSelectedYear)
                        dataMap = Object.values(currentRatioObj);
                    } else if (key === 'net_working_capital_ratio') {
                        let netWorkingCapRatioObj = netWorkingCapitalRatioCalculation(props.forecastVals, compareSelectedYear)
                        dataMap = Object.values(netWorkingCapRatioObj);
                    } else if (key === 'net_working_capital') {
                        let netWorkingCapitalObj = netWorkingCapitalCalculation(props.forecastVals, compareSelectedYear)
                        dataMap = Object.values(netWorkingCapitalObj)
                    } else if (key === 'total_revenue_growth_rate') {
                        let totalRevenueGR = monthlyTotalRevenueGRCalc(props.forecastVals, compareSelectedYear)
                        dataMap = Object.values(totalRevenueGR);
                    } else if (sheet === 'pnl' || sheet === 'balance_sheet') {
                        const forecast = props.forecastVals?.[key] ? props.forecastVals?.[key]?.[compareSelectedYear] : undefined;
                        let monthsAvailable = 0;
                        let useableMonths = monthlyCalcs?.['you']?.['cash']?.[selectedYear] ? Object.values(monthlyCalcs?.['you']?.['cash']?.[selectedYear]) : [];
                        useableMonths.forEach(thing => thing !== null && !isNaN(thing) ? monthsAvailable += 1 : null);
                        dataMap = MonthlyPNLandBalValues(monthsAvailable, sheet, key, forecast, compareSelectedYear, props.forecastVals)
                    } else {
                        let returnObj = {};
                        let metricValues = _.pickBy(props.forecastVals?.[key]?.[compareSelectedYear], _.isNumber);
                        for (let month in metricValues) {
                            returnObj[month] = metricValues[month]
                        }
                        dataMap = Object.values(returnObj);
                    }
                }
            } else {
                let returnObj = {};
                let metricValues = _.pickBy(props.compareMetrics?.[key], _.isNumber);
                for (let month in metricValues) {
                    returnObj[month] = metricValues[month]
                }
                dataMap = Object.values(returnObj);
            }
        }
        return dataMap
    }

    const MetricNotes = ({ noteProps, parentNotes }) => {
        const [metricNotes, setMetricNotes] = useState('' || parentNotes)
        const [timer, setTimer] = useState(null)
        const [count, setCount] = useState(0);

        const handleNewNotes = (newNotes) => {
            let notes = newNotes.length >= 1100 ? newNotes.substring(0, 1100) : newNotes;
            setMetricNotes(notes)

            clearTimeout(timer)
            const newTimer = setTimeout(() => {
                props.handleMetricNotes(noteProps.metricRow.relatedCheckedKey, newNotes);
            }, 2000)
            setTimer(newTimer)
        }

        return (
            <>
                <h3 style={{ 'color': '#000000', 'fontSize': '18px', 'fontWeight': 'normal', 'margin': '5px', 'textAlign': 'center' }}>Notes</h3>
                {props.pdf
                    ? <div className='my-notes-dashboard'>{metricNotes}</div>
                    : <textarea className='my-notes-dashboard' value={metricNotes} onChange={(e) => handleNewNotes(e.target.value)} />
                }
            </>
        )
    }

    const costOfTurnover = () => {
        const lostProductivity = .2;
        const lostProductivityTime = .125;
        const lostWagesTime = .125;
        const employeeProductivityDecline = .5;
        const employeeProductivityDeclineTime = .185;

        // Cost of Turnover Formula
        // (Your Turnover Rate(year) − Peer Turnover Rate(year)) 
        // * (Number of Employees(year) 
        // * ((Revenue Per Employee(year) * Lost Productivity * Lost Productivity Time) 
        //   + (Average Wages and Salaries(year) * Lost Wages Time ) 
        //   + ((.25 * Training(year))/Number of Employees(year))
        //   + (Revenue Per Employee(year) * Employee Productivity Decline * Employee Productivity Decline Time)))

        if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
            if (calcs.you.turnover_rate[props.year] !== 0 && calcs.you.total_number_of_employees[props.year] !== 0 && calcs.you.revenue_per_employee[props.year] !== 0 && calcs.you.average_wages_and_salaries[props.year] !== 0) {
                return ((calcs.you.turnover_rate[props.year] - calcs.avg.turnover_rate[props.year])
                    * (calcs.you.total_number_of_employees[props.year]
                        * ((calcs.you.revenue_per_employee[props.year] * lostProductivity * lostProductivityTime)
                            + (calcs.you.average_wages_and_salaries[props.year] * lostWagesTime)
                            + ((calcs.you.training[props.year] * .25) / calcs.you.total_number_of_employees[props.year])
                            + (calcs.you.revenue_per_employee[props.year] * employeeProductivityDecline * employeeProductivityDeclineTime))));
            } else {
                return 0;
            };
        }

        return 0;
    }

    const buildRankingTable = (positionStyles, chartProps, rankingInfo) => {
        let top10 = rankingInfo ? rankingInfo[chartProps.metricKey].slice(0, 10) : [];
        let cellLength = chartProps.keys.length;

        return (
            <div className='snapshot-table' key={chartProps.key} style={props.pdf ? { minWidth: chartProps.widthPx, minHeight: chartProps.heightPx, width: chartProps.widthPx, height: chartProps.heightPx, ...positionStyles } : {}}>
                <table>
                    <thead>
                        <tr>
                            <th className='snapshot-title snap-cell' colSpan={cellLength}>{chartProps.title}</th>
                        </tr>
                        <tr className='snapshot-header-cols'>
                            {
                                (chartProps.headerCols.map((h) => {
                                    return <th key={`${chartProps.title}-${h}`}><div className='snap-cell'><p>{h}</p></div></th>
                                }))
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (top10.map((s, i) => {
                                let rowColor = i % 2 === 0 ? { backgroundColor: '#F5F5F5' } : {}
                                return (
                                    <tr key={`${chartProps.key}-row-${i}`} style={rowColor}>
                                        {chartProps.keys.map((k) => {
                                            if (Array.isArray(k)) {
                                                let key = k[0]
                                                return <td key={`snap-cell-${k}`}><div className='snap-cell'><p>{format(k[1], s[key])}</p></div></td>
                                            } else {
                                                return <td key={`snap-cell-${k}`}><div className='snap-cell'><p>{s[k]}</p></div></td>
                                            }
                                        })}
                                    </tr>
                                )
                            }))
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    const getPrintPositionStyles = (item) => {
        let setParentWidths = {
            "34mm": 127,
            "69mm": 127,
            "104mm": 127,
            "139mm": 128,
            "174mm": 128.5,
            "209mm": 129
        }
        let setChildWidth = setParentWidths[props.positionStyles['width']]

        const printStyles = { position: 'absolute', border: 'none', borderRadius: '15px', backgroundColor: 'white' }
        let width = item.w > 1 ? (item.w * 127) + (item.w - 1) : item.w * setChildWidth
        let setHeightNum = item.h > 4 ? 4 : item.h
        let height = setHeightNum > 1 ? (setHeightNum * 127) + (setHeightNum - 1) : setHeightNum * 127
        let posX = (item.x * setChildWidth) + ((item.x + 1) * 2)
        let posY = (item.y * 127) + ((item.y + 1) * 2)

        printStyles.width = `${width}px`
        printStyles.height = `${height}px`
        printStyles.left = `${posX}px`
        printStyles.top = `${posY}px`
        return printStyles
    }

    // react-grid-layout recommends memoizing items in layout to optimize rendering
    let layoutItems = useMemo(() => {
        return props.dashboardLayout.map((l) => {
            let positionStyles = props.pdf ? getPrintPositionStyles(l) : {}
            let widthPx = props.pdf ? (l.w * 127) : (l.w * colWidthsPx)
            let heightPx = props.pdf ? (l.h * 127) : (l.h * colHeightPx)

            if ((props.page === 'money' && l.i.includes('_bar_chart')) || (props.page === 'money' && l.i.includes('_chart')) || (props.page === 'people' && l.i.includes('chart')) || (props.page === 'customers' && l.i.includes('chart'))) {
                let parentMetric = props.parentDashBoardInfo
                let chartKey = l.key
                let youData, compareData, chartOptions;
                let page = props.page
                if (page === 'money' && ['people_financial_detail', 'people_kpi'].includes(parentMetric.sheet)) {
                    page = 'people'
                } else if (page === 'money' && ['customers_financial_detail', 'customers_kpi'].includes(parentMetric.sheet)) {
                    page = 'customers'
                }
                let finalFormat = !['kfis', 'people_financial_detail', 'customers_financial_detail', 'people_kpi', 'customers_kpi'].includes(parentMetric?.sheet) && props.displayColumnsBy === 'Months' ? 'money' : parentMetric.format
                if ((parentMetric?.sheet === 'people_financial_detail' && props.displayColumnsBy === 'Months') || (parentMetric?.sheet === 'people_financial_detail' && props.reportPeriod === 'Year to Date')) {
                    finalFormat = 'money'
                } else if (parentMetric?.sheet === 'people_financial_detail' && props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
                    finalFormat = 'percent'
                }

                let chartProps = {
                    i: l.i,
                    chartType: 'editableChart',
                    aggregateYTDDate: props.aggregateYTDDate || null,
                    companyYTDDate: props.companyYTDDate || null,
                    format: finalFormat,
                    compareWith: props.compareWith || null,
                    compareWithTitle: props.monthlyCompareWithTitle || null,
                    displayColumnsBy: props.displayColumnsBy || null,
                    fiscalYearEnd: props.fiscalYearEnd || '12/31',
                    key: parentMetric.key,
                    months: props.monthLabels || null,
                    onManyReports: parentMetric ? parentMetric['onManyReports'] : false,
                    page: page,
                    parentKey: parentMetric.key,
                    percentOfRevenueKey: parentMetric.percentOfRevenueKey,
                    pdf: props.pdf,
                    reportPeriod: props.reportPeriod,
                    styles: props.parentStyles || { seriesOne: { type: 'column' }, seriesTwo: { type: 'column' } },
                    title: titleSetter(parentMetric),
                    widthPx: widthPx,
                    heightPx: heightPx,
                    years: (props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date') ? [props.year - 1, props.year] : props.yearRange,
                }

                if (['pnl', 'balance_sheet', 'people_financial_detail', 'customers_financial_detail', 'people_kpi', 'customers_kpi'].includes(parentMetric.sheet)) {
                    youData = buildYouLineOrColData(chartProps, parentMetric.sheet);
                    compareData = props.compareWith !== 'None' && props.compareWith !== 'Default:None' ? buildCompareLineOrColData(chartProps, parentMetric.sheet) : null;
                }

                if (parentMetric.sheet === 'cash_flow') {
                    if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
                        let cashValues = AnnualCashFlowValues(calcs, avgAnnualCalcs, props.calcsAvgType, props.yearRange, parentMetric.key)
                        youData = []
                        compareData = []
                        props.yearRange.forEach(year => {
                            const youVal = cashValues['you' + year];
                            const avgVal = cashValues['avg' + year];
                            youData.push(typeof youVal !== 'undefined' ? youVal : null);
                            if (props.compareWith !== 'None' && props.compareWith !== 'Default:None') {
                                compareData.push(typeof avgVal !== 'undefined' ? avgVal : null);
                            }
                        })
                    }

                    if (props.displayColumnsBy === 'Months') {
                        youData = []
                        compareData = []
                        let year1 = selectedYear;
                        let year2 = previousYear;
                        let year3 = null;
                        let year4 = null;
                        let isForecast = false
                        const calcsYou = monthlyCalcs.you;
                        const previousYearCalcsYou = monthlyCalcs.you
                        let compareVals = null;
                        let prevYearCompareVals = null;
                        if (props.compareWith === 'Peers' || props.compareWith === 'Default:Peers') {
                            compareVals = avgMonthlyCalcs.avg;
                            year3 = selectedYear
                            year4 = previousYear
                        }
                        if (props.compareWith === 'YOY' || props.compareWith === 'Default:YOY') {
                            compareVals = monthlyCalcs.you;
                            year3 = previousYear
                            year4 = twoYearsAgo
                        }
                        if (props.compareWith && props.compareWith.includes('Forecast')) {
                            isForecast = true
                            let forecastRevenue = props.forecastVals?.['total_revenue'];
                            let compareSelectedYear = forecastRevenue ? Object.keys(forecastRevenue)[0] : null
                            compareVals = props.forecastVals
                            year3 = compareSelectedYear
                            year4 = previousYear
                        }
                        let { youValues, compareValues } = MonthlyCashFlowValues(parentMetric.key, calcsYou, year1, year2, compareVals, year3, year4, isForecast)
                        Object.values(youValues).slice(0, endMonthOfSelectedYear).forEach(yv => {
                            youData.push(yv)
                        })
                        if (props.compareWith !== 'None' && props.compareWith !== 'Default:None') {
                            Object.values(compareValues).slice(0, endMonthOfSelectedYear).forEach(cv => {
                                compareData.push(cv)
                            })
                        }
                    }

                    if (props.reportPeriod === 'Year to Date') {
                        function commonSizeValue(props) {
                            return props.totalRevenue ? (props.value / props.totalRevenue) : 0
                        }

                        const youSelectedYearTotalRevenue = monthlyCalcs?.you?.total_revenue?.[selectedYear];
                        const youPreviousYearTotalRevenue = monthlyCalcs?.you?.total_revenue?.[previousYear];
                        const youSelectedYearYTDRevMonths = getYTDMonths(youSelectedYearTotalRevenue, ytd_months);
                        const youPreviousYearYTDRevMonths = getYTDMonths(youPreviousYearTotalRevenue, ytd_months);
                        const youSelectedYearYTDRevenue = Object.values(youSelectedYearYTDRevMonths).reduce((a, b) => a + b, 0)
                        const youPreviousYearYTDRevenue = Object.values(youPreviousYearYTDRevMonths).reduce((a, b) => a + b, 0)
                        const compareSelectedYearTotalRevenue = avgMonthlyCalcs?.avg?.total_revenue?.[selectedYear];
                        const comparePreviousYearTotalRevenue = avgMonthlyCalcs?.avg?.total_revenue?.[previousYear];
                        const compareSelectedYearYTDRevMonths = getYTDMonths(compareSelectedYearTotalRevenue, ytd_months);
                        const comparePreviousYearYTDRevMonths = getYTDMonths(comparePreviousYearTotalRevenue, ytd_months);
                        const compareSelectedYearYTDRevenue = Object.values(compareSelectedYearYTDRevMonths).reduce((a, b) => a + b, 0)
                        const comparePreviousYearYTDRevenue = Object.values(comparePreviousYearYTDRevMonths).reduce((a, b) => a + b, 0)

                        let newerYearVals = YTDCashFlowValues(parentMetric.key, monthlyCalcs, avgMonthlyCalcs, props.year, props.year - 1, ytd_months);
                        let youSelectedYearVal = newerYearVals['youValue'];
                        let compareSelectedYearVal = newerYearVals['compareValue'];

                        let olderYearVals = YTDCashFlowValues(parentMetric.key, monthlyCalcs, avgMonthlyCalcs, props.year - 1, props.year - 2, ytd_months);
                        let youPreviousYearVal = olderYearVals['youValue'];
                        let comparePreviousYearVal = olderYearVals['compareValue'];

                        let valuePYMonthlyCommonSize = commonSizeValue({ year: props.year - 1, value: youPreviousYearVal, totalRevenue: youPreviousYearYTDRevenue })
                        let valuePYPeersMonthlyCommonSize = props.compareWith === 'Peers' ? commonSizeValue({ year: props.year - 1, value: comparePreviousYearVal, totalRevenue: comparePreviousYearYTDRevenue }) : null;
                        let valueCYMonthlyCommonSize = commonSizeValue({ year: props.year, value: youSelectedYearVal, totalRevenue: youSelectedYearYTDRevenue })
                        let valueCYPeersMonthlyCommonSize = props.compareWith === 'Peers' ? commonSizeValue({ year: props.year, value: compareSelectedYearVal, totalRevenue: compareSelectedYearYTDRevenue }) : null;

                        youData = [valuePYMonthlyCommonSize, valueCYMonthlyCommonSize]
                        compareData = props.compareWith === 'Peers' ? [valuePYPeersMonthlyCommonSize, valueCYPeersMonthlyCommonSize] : null;
                    }
                }

                if (parentMetric.sheet === 'kfis') {
                    if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
                        let kfisValues = AnnualKFIsValues(calcs, avgAnnualCalcs, props.calcsAvgType, props.yearRange, parentMetric.key)
                        youData = []
                        compareData = []
                        props.yearRange.forEach(year => {
                            youData.push(typeof kfisValues[year] !== 'undefined' ? kfisValues[year] : null)
                            if (props.compareWith !== 'None' && props.compareWith !== 'Default:None') {
                                compareData.push(
                                    typeof kfisValues['avg' + year] !== 'undefined' ? kfisValues['avg' + year] : null
                                )
                            }
                        })
                    }

                    if (props.displayColumnsBy === 'Months') {
                        youData = []
                        compareData = []
                        let numberOfMonths = 0
                        let useableMonths = monthlyCalcs?.['you']?.['cash']?.[selectedYear] ? Object.values(monthlyCalcs?.['you']?.['cash']?.[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
                        useableMonths.forEach(thing => thing !== null ? numberOfMonths += 1 : null)
                        let isForecast = props.compareWith && props.compareWith.includes('Forecast')
                        let { youValues, compareValues } = MonthlyKFIsValues(parentMetric, numberOfMonths, props.compareWith, selectedYear, previousYear, twoYearsAgo, monthlyCalcs.you, avgMonthlyCalcs.avg, isForecast, props.forecastVals)
                        Object.values(youValues).forEach(yv => {
                            youData.push(yv)
                        })
                        if (props.compareWith !== 'None' && props.compareWith !== 'Default:None') {
                            Object.values(compareValues).forEach(cv => {
                                compareData.push(cv)
                            })
                        }
                    }

                    if (props.reportPeriod === 'Year to Date') {
                        youData = []
                        compareData = []
                        chartProps.years.forEach(year => {
                            let youKfiMetric, peersKfiMetric = null
                            let youMetric = calculateKFIMetric(parentMetric.key, monthlyCalcs.you, year, year - 1, ytd_months);
                            youData.push(youMetric)
                            if (props.compareWith === 'Peers') {
                                let peersMetric = calculateKFIMetric(parentMetric.key, avgMonthlyCalcs.avg, year, year - 1, ytd_months);
                                compareData.push(peersMetric)
                            }
                        })
                    }
                }
                chartOptions = getLineOrColOptions(chartProps, youData, compareData, props.fiscalYearEnd);

                return (
                    <div key={l.i} style={positionStyles}>
                        <button className='no-drag edit-dash-item-btn' onClick={() => props.handleEditChartModal('open', chartProps, chartOptions)}><FontAwesomeIcon icon={faPencil} /></button>
                        <HighchartsReact ref={setNewRef} containerProps={{ style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' }, key: l.i, id: l.i }} highcharts={Highcharts} options={chartOptions} />
                    </div>
                )
            } else if (l.i.includes('impact_box')) {
                let parentMetric = props.parentDashBoardInfo
                let finalCopy = parentMetric.copy
                let boxStyle = {
                    'backgroundColor': 'white',
                    'display': 'flex',
                    'flexDirection': 'column',
                    'justifyContent': 'space-evenly',
                    'alignItems': 'center',
                    'height': '100%',
                    'width': '100%',
                    'textAlign': 'center'
                }
                let statusTextColor = {
                    'fontSize': '24px',
                    'fontWeight': 'bold'
                }
                let allStyles = { ...boxStyle, ...positionStyles }
                statusTextColor['fontSize'] = props.pdf ? '18px' : '24px'
                let impactTextStyle = props.pdf ? { fontSize: '0.7em' } : { fontSize: '15px' }
                if (l.i.includes('labor_cogs')) {
                    finalCopy = `Labor COGS - ${parentMetric.copy}`
                }

                if (props.compareWith === 'None' || props.compareWith === 'Default:None') {
                    return (
                        <div key={l.i} className='impact-square' style={allStyles}>
                            <div style={{ marginBottom: '5px' }}>
                                <div style={impactTextStyle}>{`${finalCopy} Impact Box`}</div>
                            </div>
                            <div>
                                <div style={impactTextStyle}>Compare with None Selected</div>
                            </div>
                        </div>
                    )
                } else {
                    let realCalcs = calcs
                    let aggregateCalcs = avgAnnualCalcs
                    if (props.displayColumnsBy === 'Months' || props.reportPeriod === 'Year to Date') {
                        realCalcs = monthlyCalcs
                        aggregateCalcs = avgMonthlyCalcs
                    }

                    // Annual PNL and Balance Sheet use common_size keys, Cash Flow and Kfis are calculated
                    let { copy, impactText, status, deltaCommonSize, impactValueFormatted } = buildImpactBox(parentMetric, parentMetric['sheet'], props.displayColumnsBy, props.reportPeriod, props.compareWith, props.year, props.yearRange, ytd_months, endMonthOfSelectedYear, realCalcs, aggregateCalcs, props.calcsAvgType, props.monthlyCompareWithTitle, props.forecastVals, selectedYear, previousYear, twoYearsAgo, threeYearsAgo)
                    if (!impactText) {
                        impactText = noSpecificTextMaker(finalCopy, status, impactValueFormatted, deltaCommonSize, props.compareWith, props.monthlyCompareWithTitle)
                    }
                    let impactTextClass = impactBoxStatusColor(status)

                    if (impactText) {
                        return (
                            <div key={l.i} className='impact-square' style={allStyles}>
                                <div style={{ marginBottom: '5px' }}>
                                    <span className={impactTextClass} style={statusTextColor}>{deltaCommonSize}</span>
                                    <div style={impactTextStyle}>{impactText['text1']}</div>
                                </div>
                                <div>
                                    <span className={impactTextClass} style={statusTextColor}>{impactValueFormatted}</span>
                                    <div style={impactTextStyle}>{impactText['textNotesSection']}</div>
                                </div>
                            </div>
                        )
                    }
                }
            } else if (l.i.includes('notes')) {
                return (
                    <div key={l.i} style={positionStyles}>
                        {props.pdf ? null : <button className='no-drag lock-btn' onClick={() => props.handleToggleDraggable(l.i, 'moneyDashboard', props.parentDashBoardInfo)}>{l.isDraggable ? <FontAwesomeIcon icon={faLockOpen} /> : <FontAwesomeIcon icon={faLock} />}</button>}
                        <MetricNotes noteProps={l} parentNotes={props.parentNotes} />
                    </div>
                )
            } else {
                let chart;
                let page = props.page
                let parentMetric = props.parentDashBoardInfo
                if (page === 'practice') {
                    chart = pageCharts['practice']['dashboard_items'].find(c => c.key === l.i);
                } else if ((page === 'money' && ['customers_financial_detail', 'customers_kpi'].includes(parentMetric.sheet)) || page === 'customers') {
                    chart = pageCharts['customers']['dashboard_items'].find(c => c.key === l.i);
                } else if ((page === 'money' && ['people_financial_detail', 'people_kpi'].includes(parentMetric.sheet)) || page === 'people') {
                    chart = pageCharts['people'].find(c => c.key === l.i);
                } else {
                    chart = moneyCharts[page].find(c => c.key === l.i);
                }

                if (page === 'money' && ['people_financial_detail', 'people_kpi'].includes(parentMetric.sheet)) {
                    page = 'people'
                } else if (page === 'money' && ['customers_financial_detail', 'customers_kpi'].includes(parentMetric.sheet)) {
                    page = 'customers'
                }

                if (chart) {
                    let chartKey = chart.key
                    let youData, compareData, chartOptions;
                    let chartProps = {
                        i: l.i,
                        aggregateYTDDate: props.aggregateYTDDate || null,
                        companyYTDDate: props.companyYTDDate || null,
                        format: chart.format,
                        headerCols: chart.headerCols,
                        compareWith: props.compareWith || null,
                        compareWithTitle: props.monthlyCompareWithTitle || null,
                        displayColumnsBy: props.displayColumnsBy || null,
                        fiscalYearEnd: props.fiscalYearEnd || '12/31',
                        key: chartKey,
                        keys: chart.keys || null,
                        metricKey: chart.metricKey || null,
                        months: props.monthLabels || null,
                        onManyReports: parentMetric ? parentMetric['onManyReports'] : false,
                        page: page,
                        parentKey: parentMetric.key,
                        pdf: props.pdf || false,
                        percentOfRevenueKey: chart.percentOfRevenueKey || parentMetric.percentOfRevenueKey || null,
                        reportPeriod: props.reportPeriod,
                        widthPx: widthPx,
                        heightPx: heightPx,
                        title: titleSetter(chart),
                        subtitle: chart.subtitle,
                        trailing12Key: chart.trailing12Key || null,
                        styles: props.parentStyles || chart.styles,
                        x: chart.x,
                        y: chart.y,
                        years: (props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date') ? [props.year - 1, props.year] : props.yearRange,
                    }

                    switch (chart.chartType) {
                        case '3DBubble':
                            chartOptions = get3DBubbleChartOptions(chartProps, props.calculations);
                            break;
                        case 'quadrantBubble':
                            if (props.page === 'practice') {
                                chartOptions = getQuadrantOptions(chartProps, props.calculations);
                            }
                            if (props.page === 'money') {
                                let chartData = { name: props.naicsCode, data: [] };
                                let dataObj = { name: props.clientName, color: '#69B144' }
                                if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
                                    dataObj.x = Math.round(calcs.you[chartProps.keys[0]][props.year])
                                    dataObj.y = Math.round(calcs.you[chartProps.keys[1]][props.year])
                                    dataObj.z = calcs.you['total_revenue'][props.year]
                                    chartData.data.push(dataObj);
                                }
                                if (props.displayColumnsBy === 'Months' || (props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date')) {
                                    const peerviewMetrics = peerviewMetricsYears[props.year]['you'];
                                    dataObj.x = peerviewMetrics.hasOwnProperty(chartProps.keys[0]) ? peerviewMetrics[chartProps.keys[0]] : 0;
                                    dataObj.y = peerviewMetrics.hasOwnProperty(chartProps.keys[1]) ? peerviewMetrics[chartProps.keys[1]] : 0;
                                    dataObj.z = props.displayColumnsBy === 'Months' && monthlyCalcs?.you?.['total_revenue']?.[selectedYear] ? objReducer(monthlyCalcs.you['total_revenue'][selectedYear].slice(0, endMonthOfSelectedYear)) : getYTDMonths(monthlyCalcs['you']['total_revenue'][props.year]).reduce((a, b) => a + b, 0);
                                    chartData.data.push(dataObj);
                                }
                                chartOptions = getQuadrantOptions(chartProps, chartData)
                            }
                            break;
                        case 'multiDataBarChart':
                            chartOptions = getMultiDataBarChartOptions(chartProps, props['rankingData'])
                            break;
                        case 'rankingTable':
                            return buildRankingTable(positionStyles, chartProps, props['rankingData'])
                            break;
                        case 'scatterPlot':
                            chartOptions = getScatterPlotOptions(chartProps, props.calculations);
                            break;
                        case 'editableChart':
                        case 'lineBar':
                            youData = buildYouLineOrColData(chartProps);
                            compareData = chartProps.compareWith !== 'None' && props.compareWith !== 'Default:None' ? buildCompareLineOrColData(chartProps) : null;
                            chartOptions = getLineOrColOptions(chartProps, youData, compareData, props.fiscalYearEnd);
                            break;
                        case 'verticalBars':
                            youData = buildVerticalBarData(chartProps, 'you');
                            compareData = chartProps.compareWith !== 'None' && props.compareWith !== 'Default:None' ? buildVerticalBarData(chartProps, chartProps.compareWith) : null;
                            chartOptions = getVerticalBarChartOptions(chartProps, youData, compareData);
                            break;
                        case 'horizontalBars':
                            let xCategories = chart.keys.map((k) => COPY[k]);
                            let hBarSeries = buildHorizonalBarSeries(chartProps);
                            chartOptions = getHorizontalBarOptions(chartProps, xCategories, hBarSeries);
                            break;
                        case 'stackedBars':
                            youData = buildAPARAgingSeries(chartProps)
                            chartOptions = getStackedColumnOptions(chartProps, youData);
                            break;
                        case 'lines':
                            let seriesTitles = chart.keys.map((k) => COPY[k])
                            let lineSeries = buildLineSeries(chartProps)
                            chartOptions = getLineChartOptions(chartProps, seriesTitles, lineSeries);
                            break;
                        case 'noChart':
                            let value = costOfTurnover();
                            return (
                                <div className='cost-of-turnover' key={chartKey}>
                                    <h3>Cost of Turnover</h3>
                                    <p>(Based on S.H.R.M. Standards)</p>
                                    <div className='turnover-border'>
                                        <h2 className='cost-of-turnover-value'>
                                            {parseMoney(Math.abs(value))}
                                        </h2>
                                        <p>{value < 0 ? 'Less' : 'More'} Than Your Peers</p>
                                    </div>
                                </div>
                            )
                    }

                    if (chart.dragTogglable) {
                        return (
                            <div key={chartKey} style={positionStyles}>
                                <button className='no-drag lock-btn' onClick={() => props.handleToggleDraggable(chartKey, '', props.parentDashBoardInfo, props.customKey)}>{l.isDraggable ? <FontAwesomeIcon icon={faLockOpen} /> : <FontAwesomeIcon icon={faLock} />}</button>
                                <HighchartsReact ref={setNewRef} containerProps={{ style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' }, key: chartKey, id: chartKey }} highcharts={Highcharts} options={chartOptions} />
                            </div>
                        )
                    } else {
                        return (
                            <div key={chartKey} style={positionStyles}>
                                {chart.chartType === "editableChart" || chart.chartType === "lineBar" ? <button className='no-drag edit-dash-item-btn' onClick={() => props.handleEditChartModal('open', chartProps, chartOptions)}><FontAwesomeIcon icon={faPencil} /></button> : null}
                                <HighchartsReact ref={setNewRef} containerProps={{ style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' }, key: chartKey, id: chartKey }} highcharts={Highcharts} options={chartOptions} />
                            </div>
                        )
                    }
                }
                return null
            }
        })

    }, [props.parentLayout, props.dashboardLayout, props.year, props.calculations, calcs, monthlyCalcs, showChart, showImpactComment])

    if (props.pdf) {
        return (
            <>
                {layoutItems}
            </>
        )
    } else {

        return (
            <ReactGridLayout
                className='layout'
                draggableCancel=".no-drag"
                layout={props.dashboardLayout}
                cols={props.childWidth}
                rowHeight={199}
                onDragStart={(a, b, c, d, e) => e.stopPropagation()}
                isDraggable={true}
                isDroppable={true}
                isResizable={true}
                preventCollision={true}
                onResizeStop={(layout, oldItem, newItem) => {
                    // Force reflow() on specific highchart item when user resizes it.
                    let item = oldItem ? oldItem : newItem;
                    let checkChartRefs = _.isEmpty(chartRefs)
                    if (!checkChartRefs && item && chartRefs[item.i]) {
                        chartRefs[item.i].chart.reflow();
                    }
                    window.dispatchEvent(new Event('resize'))
                }}
                onLayoutChange={(layout) => {
                    if (props.customLayout) {
                        // handleCustomLayoutChange
                        props.handleOnLayoutChange(props.customKey, 'childMyDashBoard', layout, props.parentDashBoardInfo)
                    } else {
                        props.handleOnLayoutChange('childMyDashBoard', layout, props.parentDashBoardInfo)
                    }
                    // Force reflow() on highcharts when different display columns by filter submits
                    // For some odd reason the highcharts are not resizing to new layout like before
                    let checkChartRefs = _.isEmpty(chartRefs)
                    if (!checkChartRefs) {
                        const childWidthHelper = { 1: 204, 2: 210, 3: 212, 4: 212, 5: 214, 6: 214 }
                        for (const chartRef in chartRefs) {
                            if (chartRefs[chartRef].chart) {
                                let chartInfo = layout.find(l => l.i === chartRef)
                                if (chartInfo) {
                                    let chartWidth = chartInfo.w * childWidthHelper[chartInfo.w];
                                    let chartHeight = chartInfo.h * 204;
                                    chartRefs[chartRef].chart.setSize(chartWidth, chartHeight)
                                } else {
                                    chartRefs[chartRef].chart.reflow();
                                }
                            }
                        }
                    }
                }}
            >
                {layoutItems}
            </ReactGridLayout>
        )
    }
}
export default ChildDashboard;